/**
 * Custom error types for GameOrchestrator
 */
export class GameOrchestratorError extends Error {
    code;
    constructor(message, code) {
        super(message);
        this.code = code;
        this.name = 'GameOrchestratorError';
    }
}
/**
 * Game status enumeration
 */
export var GameStatus;
(function (GameStatus) {
    GameStatus["NOT_STARTED"] = "NOT_STARTED";
    GameStatus["IN_PROGRESS"] = "IN_PROGRESS";
    GameStatus["AWAITING_CHOICE"] = "AWAITING_CHOICE";
    GameStatus["PAUSED"] = "PAUSED";
    GameStatus["ENDED"] = "ENDED";
})(GameStatus || (GameStatus = {}));
//# sourceMappingURL=types.js.map